import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { LoadingIndicator } from 'ecs-react-components/dist/index.es';

class LoadingIndicatorContainer extends React.Component {
  render = () => (
    this.props.loadingIndicators && this.props.loadingIndicators.indexOf(this.props.loadingKey) > -1 ?
    <LoadingIndicator size={this.props.size} /> :
      this.props.children
  );
}

LoadingIndicatorContainer.propTypes = {
  children: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  loadingIndicators: PropTypes.array,
  size: PropTypes.string,
  loadingKey: PropTypes.string,
};

const mapStateToProps = (state) => ({
  loadingIndicators: state.loadingIndicator.loadingIndicators,
});

export default connect(mapStateToProps)(LoadingIndicatorContainer);